import { bindable } from 'aurelia-framework';

export class Files {

	@bindable items = [];
	@bindable controller;
	

}